"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Spinner_1 = require("../../Spinner");
var features_1 = require("../features");
exports.gridLoaderId = 'grid-loader';
var GridLoaderWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    ",
    "\n"])), function (props) {
    if (props.dataLength > 0) {
        return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                position: absolute;\n                top: ", "px;\n                left: 0;\n                bottom: 0;\n                right: 0;\n                background-color: rgba(255, 255, 255, 0.7);\n                z-index: 10;\n            "], ["\n                position: absolute;\n                top: ", "px;\n                left: 0;\n                bottom: 0;\n                right: 0;\n                background-color: rgba(255, 255, 255, 0.7);\n                z-index: 10;\n            "])), props.headerHeight);
    }
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            flex-grow: 1;\n            padding: 20px 0;\n        "], ["\n            flex-grow: 1;\n            padding: 20px 0;\n        "])));
});
var GridLoader = function () {
    var _a = features_1.useGridContext().state, data = _a.data, headerHeight = _a.headerHeight, isLoading = _a.isLoading;
    if (!isLoading) {
        return null;
    }
    return (react_1.default.createElement(GridLoaderWrapper, { "data-selector-id": exports.gridLoaderId, dataLength: data.length, headerHeight: headerHeight },
        react_1.default.createElement(Spinner_1.Spinner, { size: 50 })));
};
exports.default = GridLoader;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=GridLoader.js.map